import http from "../../http-common";
import authHeader from "../../services/authHeader";
import { CVDATA_API, CVDATA_UPDATE_API } from "../../api";

export const getCvs = () => {
    return http.get(`${CVDATA_API}/1`, {
        
        headers: authHeader(),
    });
}

export const updateLead = (data)=>{
    return http.put(`${CVDATA_API}/1`,data, {
        headers: authHeader()
    });
}

export const createCv = (data) => {
    return http.post(`${CVDATA_API}/1`, data, {
        headers: authHeader(),
    });
}

export const updateCv = (id,data) => {
    return http.post(`${CVDATA_UPDATE_API}/${id}`, data, {
        headers: authHeader(),
    });
}